var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{attrs:{"title":_vm.$t('trade.add-order')}},[_c('SelectBox',{attrs:{"options":_vm.orderTypes},model:{value:(_vm.attachOrderType),callback:function ($$v) {_vm.attachOrderType=$$v},expression:"attachOrderType"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }